import React, { Component } from 'react'
import PropTypes from 'prop-types'

const propType = {
  onButtonClick: PropTypes.func,
}

export default class ButtonLogin extends Component {
  handleButtonClick = (e) => {
    this.props.onButtonClick(e)
  }

  render() {
    return (
      <div className="login-form-btn-container">
        <button className="login-form-btn" onClick={this.handleButtonClick}>
          Login
        </button>
      </div>
    )
  }
}

ButtonLogin.propTypes = propType
